import { BodyText } from '@if/mui'
import { useTranslation } from 'react-i18next'

const PrequalNotStarted = () => {
  const { t } = useTranslation()
  return <BodyText>{t('viewCreditApplication.prequalNotStarted')}</BodyText>
}

export default PrequalNotStarted
